import React from 'react';
import { AuthContextProvider, useAuthContext } from './AuthContext';
import { Env } from './config';
import { Header } from './Header';
import { useCurrentUser, UserProvider } from './UserContext';

const Provider: React.FC<
  React.PropsWithChildren<React.ComponentProps<typeof AuthContextProvider>>
> = ({ children, ...props }) => {
  return (
    <AuthContextProvider {...props}>
      <UserProvider>{children}</UserProvider>
    </AuthContextProvider>
  );
};
export { Provider as AuthContextProvider, useAuthContext, useCurrentUser, Env, Header };
